
import { useEffect, useState } from 'react';
import axios from 'axios';
 import { useNavigate } from 'react-router-dom'; // make sure you have this
import Swal from 'sweetalert2';



const Dashboard = () => {
  const [loading, setLoading] = useState(true); // start loader immediately
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const colorMap = {
    1: { color: 'primary', backgroundColor: '#799EFF' },
    2: { color: 'warning', backgroundColor: '#FFDE63' },
    3: { color: 'success', backgroundColor: '#A3DC9A' },
  };

  const fetchDashboardData = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(
        'https://codydealms.codydeasoftech.in/api/teacher/dashboard',
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.status) {
        const items = res.data.data.studeymaterialCategories || [];
        const merged = items.map((item) => ({
          ...item,
          ...(colorMap[item.id] || {}),
        }));
        setCategories(merged);
      }
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401 || status === 403) {
        localStorage.removeItem('token');
        navigate('/login', { replace: true });
      } else if (status === 429) {
        Swal.fire({
          icon: 'warning',
          title: 'Too Many Requests',
          text: 'Please wait a few seconds and try again.',
        });
      } else {
        console.error('Error fetching dashboard data:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load dashboard. Please try again later.',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Show loader for at least 3 seconds
    const timer = setTimeout(() => {
      fetchDashboardData();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  
  if (loading) return <div className="text-center py-5">Loading...</div>;

  return (
    <>




      {!loading && (
        <div className="container py-4" style={{ maxWidth: '1462px' }}>
          <h4 className="mb-4 fw-bold">Dashboard</h4>
          <div className="row g-4">
            {categories.map((item, index) => (
              <div className="col-md-3" key={index}>
                <div
                  className="card h-100 border"
                  style={{
                    minHeight: '160px',
                    borderRadius: '10px',
                    boxShadow: '0 8px 20px rgba(88, 86, 214, 0.2)',
                  }}
                >
                  <div
                    className="card-body d-flex align-items-center px-4"
                    style={{
                      backgroundColor: item.backgroundColor || '#eaf0ff',
                      minHeight: '80px',
                      borderTopLeftRadius: '10px',
                      borderTopRightRadius: '10px',
                    }}
                  >
                    <i
                      className={`${item.icon_class.replace(/\s+/g, ' ').trim()} text-${
                        item.color || 'primary'
                      }`}
                      style={{ fontSize: '2.7rem', marginRight: '1.5rem' }}
                    ></i>

                    <h4 className="card-title mb-0">{item.name}</h4>
                  </div>

                  <div
                    className="border-top text-end px-3 py-2 bg-light"
                    style={{
                      borderBottomLeftRadius: '30px',
                      borderBottomRightRadius: '30px',
                    }}
                  >
                    <button
                      onClick={() => navigate(`/${item.slug}`)}
                      className={`btn btn-sm btn-${item.color || 'primary'}`}
                    >
                      Go to list →
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {/* Example static cards */}
            <div className="col-md-3">
              <div
                className="card h-100 border"
                style={{
                  minHeight: '160px',
                  borderRadius: '10px',
                  boxShadow: '0 8px 20px rgba(88, 86, 214, 0.2)',
                }}
              >
                <div
                  className="card-body d-flex align-items-center px-4"
                  style={{
                    backgroundColor: '#b5e2fa',
                    minHeight: '80px',
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px',
                  }}
                >
                  <i
                    className="fa-solid fa-clipboard-list"
                    style={{ fontSize: '2.7rem', marginRight: '1.5rem', color: '#3087b9' }}
                  ></i>
                  <h4 className="card-title mb-0">Exam List</h4>
                </div>
                <div
                  className="border-top text-end px-3 py-2 bg-light"
                  style={{
                    borderBottomLeftRadius: '30px',
                    borderBottomRightRadius: '30px',
                  }}
                >
                  <button
                    className="btn btn-sm text-white"
                    style={{ backgroundColor: '#3087b9' }}
                    onClick={() => navigate('/exam')}
                  >
                    Go to list →
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className="card h-100 border"
                style={{
                  minHeight: '160px',
                  borderRadius: '10px',
                  boxShadow: '0 8px 20px rgba(88, 86, 214, 0.2)',
                }}
              >
                <div
                  className="card-body d-flex align-items-center px-4"
                  style={{
                    backgroundColor: '#67e1d9',
                    minHeight: '80px',
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px',
                  }}
                >
                  <i
                    className="fa-solid fa-clipboard-list"
                    style={{ fontSize: '2.7rem', marginRight: '1.5rem', color: '#308c9b' }}
                  ></i>
                  <h4 className="card-title mb-0">Exam Papers</h4>
                </div>
                <div
                  className="border-top text-end px-3 py-2 bg-light"
                  style={{
                    borderBottomLeftRadius: '30px',
                    borderBottomRightRadius: '30px',
                  }}
                >
                  <button
                    className="btn btn-sm text-white"
                    style={{ backgroundColor: '#308c9b' }}
                    onClick={() => navigate('/exam-paper')}
                  >
                    Go to list →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;




